import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.css']
})
export class DrawerComponent implements OnInit {
  
  constructor() { }

  selectedItem;
  items = [
    { type: "Group", title: "Servicio técnico",  items: [
      { id: "3", type: "Button", title: "Pendientes", link: "openTickets", params: { status: "PENDIENTE"} },
      { id: "0", type: "Button", title: "Abiertos", link: "openTickets", params: { status: "ABIERTO"} },
      { id: "1", type: "Button", title: "En espera", link: "openTickets" , params: { status: "EN ESPERA"} },
      { id: "12", type: "Button", title: "Listos", link: "openTickets", params: { status: "LISTO"} },
      { id: "2", type: "Button", title: "Cancelados", link: "openTickets", params: { status: "CANCELADO"} },
      { id: "13", type: "Button", title: "Finalizados", link: "openTickets", params: { status: "FINALIZADO"} },
      { id: "4", type: "Button", title: "Historial", link: "openTickets" },
    ]},
    { type: "Group", title: "Tecnicos", items: [
      { id: "5", type: "Button", title: "Listado", link: "tecnicos"},
      { id: "54", type: "Button", title: "Actualizaciones", link: "tecnicosActualizaciones"},
      { id: "55", type: "Button", title: "Ranking", link: "tecnicos/ranking"}
    ]},
    { id: "8", type: "Button", title: "Repuestos en espera", link: "repuestos"},
    { id: "88", type: "Button", title: "Listado repuestos", link: "listado-repuestos"},
    { id: "89", type: "Button", title: "Listado fallas", link: "listado-fallas"},
    { id: "9", type: "Button", title: "Zonas", link: "zonas"},
    { id: "10", type: "Button", title: "Crear nuevo ticket", link: ""},
    { id: "11", type: "Button", title: "Admins", link: "admins"},
    { id: "14", type: "Button", title: "Configuración General", link: "config"},
    { id: "15", type: "Button", title: "Whatsapp", link: "whatsapp"}
  ]

  ngOnInit() {
    //this.initNotificationService();
  }


  initNotificationService(){
    document.addEventListener('DOMContentLoaded', function() {
      if (!Notification) {
       alert('Desktop notifications not available in your browser. Try Chromium.');
       return;
      }
     
      if (Notification.permission !== 'granted')
       Notification.requestPermission();
     });
  }

  notification(){
    if (Notification.permission !== 'granted')
    Notification.requestPermission();
   else {
     setTimeout(() => {
      var notification = new Notification('Notification title', {
        icon: 'http://cdn.sstatic.net/stackexchange/img/logos/so/so-icon.png',
        body: 'Hey there! You\'ve been notified!',
       });
       notification.onclick = function() {
        window.open('http://stackoverflow.com/a/13328397/1269037');
       };
     }, 3000);
    
   }
  }
}
